// Makes a deep copy of arrays or objects
export const deepCopy = (object) => {
  return JSON.parse(JSON.stringify(object));
};

// Get time to perform a function, useful for testing API calls in particular
export const testPerformance = async (func) => {
  const startTime = performance.now();
  let funcResults = await func();
  const endTime = performance.now();
  console.log(`Time for function:`, (endTime - startTime) / 1000);
  return funcResults;
};
